<template>
    <ClickAndBuysStruct>
        <div
            class="uk-grid uk-grid-match uk-child-width-1-2@s uk-child-width-1-1 uk-animation-fade uk-flex-center"
            uk-grid>
            <div
                v-for="clickAndBuy in getInfos.clickAndBuys"
                :key="clickAndBuy.id">
                <ClickAndBuyElement :click-and-buy="clickAndBuy" />
            </div>
        </div>
    </ClickAndBuysStruct>
</template>

<script>
import ClickAndBuyElement from '@/views/clickandbuy/ClickAndBuyElement.vue';
import ClickAndBuysStruct from '@/views/clickandbuy/ClickAndBuysStruct.vue';

export default {
    name: 'ClickAndBuys',
    components: {
        ClickAndBuysStruct,
        ClickAndBuyElement,
    },
    mounted() {
        let self = this;
        setInterval(function () {
            if (!self.getInfos || !self.getInfos.clickAndBuy) {
                return;
            }

            self.setLunacartThemeColors(
                self.getInfos.clickAndBuy.themeBackgroundColor,
                self.getInfos.clickAndBuy.themeColor
            );
        }, 5);
    },
};
</script>

<style lang="scss" scoped></style>
